const layerShouldRender = (
  id,
  layersToggled,
  authLayers,
  serviceLayers,
  authId = ''
) => {
  const layerAuthorized =
    authLayers.includes(id.toLowerCase()) ||
    authLayers.includes(authId.toLowerCase()) ||
    authId === 'default'
  const renderLayer =
    layersToggled.includes(id) && layerAuthorized && serviceLayers.includes(id)

  return renderLayer
}

export default layerShouldRender



// WEBPACK FOOTER //
// ./src/utility/layerShouldRender.js